import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "action-btn-gp",
  templateUrl: "./action-btn-gp.component.html",
  styleUrls: ["./action-btn-gp.component.css"],
})
export class ActionBtnGpComponent implements OnInit {
  @Input() btnName;
  @Input() directLink;
  @Input() data;
  @Input() isDisable;
  @Input() isNewTab;
  @Input() iscodeDialog;
  @Input() close;
  @Input() editId: string;
  @Output() onSubmit: any = new EventEmitter<any>();

  public isAllow: boolean;
  public dialog: any = {
    showText: "",
    isDelete: true,
    isWarning: false,
    isconfirmBtn: true,
    getCode: false,
  };
  public isShow: boolean = false;
  constructor(private _router: Router, private _activeRoute: ActivatedRoute) {}

  ngOnInit() {
    let temp = JSON.parse(atob(localStorage.getItem("userData")));
    this.isAllow = temp.userType == "ADMIN" ? true : false;
  }

  goToEdit() {
    this._router.navigate(["create", this.editId], {
      relativeTo: this._activeRoute,
    });
  }

  clickBtn() {
    if (this.isNewTab) {
      window.open(this.directLink, "_blank");
    } else {
      if (this.directLink && !this.iscodeDialog) this.gobyLink();
      if (this.data || this.iscodeDialog) {
        this.isShow = true;
        this.chekcDialog();
      }
    }
  }

  chekcDialog() {
    if (this.btnName == "delete") {
      this.dialog.showText = "Are you sure delete?";
      this.dialog.isDelete = true;
      this.dialog.isWarning = false;
      this.dialog.isconfirmBtn = true;
    } else if (this.btnName == "start" || this.btnName == "end") {
      this.dialog.showText = "Are you sure " + this.btnName + " class?";
      this.dialog.isDelete = false;
      this.dialog.isWarning = true;
      this.dialog.isconfirmBtn = true;
    } else if (this.btnName == "duplicate") {
      this.dialog.showText = "Are you sure to duplicate?";
      this.dialog.isDelete = false;
      this.dialog.isWarning = true;
      this.dialog.isconfirmBtn = true;
    } else if (this.btnName == "enter" && this.iscodeDialog) {
      this.dialog.showText = "Enter the token number for the class";
      this.dialog.isDelete = false;
      this.dialog.isWarning = true;
      this.dialog.isconfirmBtn = true;
      this.dialog.getCode = true;
    } else if (this.btnName == "share") {
      this.dialog.showText = "Enter student's email for share this mock-test";
      this.dialog.isEmail = true;
      this.dialog.isDelete = false;
      this.dialog.isconfirmBtn = true;
      this.dialog.getEmail = true;
    }
  }
  onDialog(e) {
    this.isShow = e;
    if (e) {
      if (this.btnName == "start" || this.btnName == "end") {
        let obj = {
          data: this.data,
          isProgess: this.btnName == "start" ? true : false,
        };
        this.onSubmit.emit(obj);
        this.isShow = false;
      } else if (this.btnName == "enter") {
        if (this.isShow) this.gobyLink();
        this.isShow = false;
      } else if (this.btnName == "share") {
        this.data.userEmail = e;
        this.onSubmit.emit(this.data);
      } else {
        this.onSubmit.emit(this.data);
        this.isShow = false;
      }
    }
  }

  gobyLink() {
    this._router.navigateByUrl(this.directLink);
  }
  ngOnChanges(): void {
    this.isShow = this.close;
  }
}
